import { DatabaseSelectResponse } from "@tellescope/types-models";

export const parseDatabaseRecordResponse = (str: string): DatabaseSelectResponse[] | undefined => {
  try {
    const parsedJSON = JSON.parse(str);
    if (Array.isArray(parsedJSON)) {
      return parsedJSON.reduce<DatabaseSelectResponse[]>((acc, item) => {
        if (typeof item === "object" && item !== null && "text" in item && item.text) {
          const text = item.text;
          if (typeof text !== "string") return acc;
          const res: DatabaseSelectResponse = {
            text,
          };

          if ("databaseId" in item && typeof item.databaseId === "string") {
            res.databaseId = item.databaseId;
          }
          if ("recordId" in item && typeof item.recordId === "string") {
            res.recordId = item.recordId;
          }

          acc.push(res);
        }
        return acc;
      }, []);
    }

    return undefined;
  } catch {
    return undefined;
  }
};
